import React from "react";
import styled, { keyframes } from "styled-components";

import { breakpoints, colors } from "../../../../theme";

const pulse = keyframes`
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.45;
  }
`;

/**
 * Single grey content-area placeholder (not a full-section slab).
 * Heights/radii should match the real content box under section chrome.
 */
const ContentBoxSkeleton = styled.div`
  width: 100%;
  box-sizing: border-box;
  background-color: ${colors.grey.medium};
  border-radius: ${(props) => props.$radiusMobile || "12px"};
  height: ${(props) => props.$hMobile}px;
  animation: ${pulse} 1.4s ease-in-out infinite;

  ${(props) =>
    props.$maxWidth
      ? `
    max-width: ${props.$maxWidth};
    margin-left: auto;
    margin-right: auto;
  `
      : ""}

  ${(props) =>
    props.$marginTopMobile != null
      ? `
    margin-top: ${props.$marginTopMobile}px;
  `
      : ""}

  @media only screen and (min-width: ${breakpoints.tablet}) {
    height: ${(props) => props.$hTablet ?? props.$hMobile}px;
    ${(props) =>
      props.$marginTopTablet != null
        ? `margin-top: ${props.$marginTopTablet}px;`
        : ""}
  }

  @media only screen and (min-width: ${breakpoints.desktop}) {
    height: ${(props) =>
      props.$hDesktop ?? props.$hTablet ?? props.$hMobile}px;
    border-radius: ${(props) =>
      props.$radiusDesktop || props.$radiusMobile || "12px"};
    ${(props) =>
      props.$marginTopDesktop != null
        ? `margin-top: ${props.$marginTopDesktop}px;`
        : ""}
    ${(props) =>
      props.$desktopMaxWidth
        ? `
      max-width: ${props.$desktopMaxWidth};
    `
        : ""}
    ${(props) =>
      props.$desktopGrid
        ? `
      grid-column: 2;
      grid-row: 1 / span 3;
      justify-self: start;
      margin-left: 0;
      margin-right: 0;
    `
        : ""}
  }
`;

export const WhatWeProvideContentFallback = () => (
  <ContentBoxSkeleton
    aria-hidden
    $hMobile={716}
    $hTablet={616}
    $hDesktop={346}
    $radiusMobile="40px"
    $radiusDesktop="20px"
    $marginTopMobile={40}
    $marginTopDesktop={60}
  />
);

export const TechnologyContentFallback = () => (
  <ContentBoxSkeleton
    aria-hidden
    $hMobile={1029}
    $hTablet={675}
    $hDesktop={675}
    $radiusMobile="0"
    $radiusDesktop="0"
    $maxWidth="1040px"
  />
);

export const ClearPictureContentFallback = () => (
  <ContentBoxSkeleton
    aria-hidden
    $hMobile={466}
    $hTablet={393}
    $hDesktop={298}
    $radiusMobile="20px"
    $radiusDesktop="40px"
  />
);

export const ContactMeContentFallback = () => (
  <ContentBoxSkeleton
    aria-hidden
    $hMobile={659}
    $hTablet={763}
    $hDesktop={779}
    $radiusMobile="20px"
    $radiusDesktop="20px"
    $maxWidth="532px"
    $desktopMaxWidth="532px"
    $desktopGrid
  />
);
